import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import Layout from "../components/Layout";
import { useEffect } from "react";
import { usuariosService } from "../_services/usuarios.services";


export const PrivateRoute = ({ component: Component, name, isAdmin, ...rest }) => {
  const { loggedIn, user } = useSelector(({ authentication }) => authentication);

  useEffect(() => {
    const validateToken = async () => {
      const res = await usuariosService.validateToken({
        token: user.token
      });

      if(res?.ok){
        return <Redirect to="/" />;
      }
    };

    validateToken();
  }, []);

  return (
    <Route {...rest} render={(props) => {
      if (!loggedIn) {
        return <Redirect to="/" />;
      }

      if (isAdmin && (user.rol !== "admin" && user.abogado !== "A00")) {
        return <Redirect to="/" />;
      }

      return (
        <Layout name={name} >
          <Component {...props} {...rest} />
        </Layout>
      );
    }} />
  );
};